import React from "react";
import Navbar from "../../components/navbar/Navbar";
import Header from "../../components/header/Header";
import About from "../../components/about/About";
import Services from "../../components/services/Services";
import Stats from "../../components/stats/Stats";
import Partners from "../../components/partners/Partners";
import Reviews from "../../components/reviews/Reviews";
import Footer from "../../components/footer/Footer";
import CTA from "../../components/cta/CTA";
import ScrollToTop from "react-scroll-to-top";

import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <div className="home"> 
      {/* <Helmet>
        <title>
          Madison Power Systems | Custom Cables, Starters & Alternators Since
          1967
        </title>
        <meta
          name="description"
          content="Madison Power Systems specializes in custom parking brake cables, control levers, starters, alternators, and hard-to-find cable solutions for automotive, commercial, and industrial equipment."
        />
        <meta
          name="keywords"
          content="custom cables, parking brake cables, control levers, starters, alternators, industrial cables, automotive cables, trailer cables, discontinued cables"
        />
        <link rel="canonical" href="https://madisonpowersystems.com/" />
      </Helmet> */}
      <Helmet> 
  <title>Madison Power Systems | Custom Cables, Brakes, Starters & Alternators</title>
  <meta
    name="description"
    content="Since 1967, Madison Power Systems has specialized in custom cables, discontinued cables, control levers, parking brakes, starters, alternators, and batteries. Serving customers across the USA, Canada, Mexico, Michigan, Ohio, and beyond."
  />
  <meta
    name="keywords"
    content="Madison Power Systems, custom cables, control cables, push pull cable, vernier cable, electronic vernier control, throttle cable, pto cable, brake cable, discontinued cables, parking brakes, control levers, starters, alternators, batteries, trailer parts, automotive parts, industrial parts, USA, Canada, Mexico, Michigan, Ohio"
  />
  <link rel="canonical" href="https://madisonpowersystems.com/" />
</Helmet>

      <div className="home-container">
        <Navbar />
        <Header />
        <About />
        <Services />
        <Stats />
        <Partners />
        <Reviews />
        <CTA />
        <Footer />
        <ScrollToTop smooth />
      </div>
    </div>
  );
};

export default Home;
